export default function (signature) {
  if (!signature) {
    return null;
  }
  const prepare = signature.trim().toLowerCase();
  if (prepare.endsWith('.png')) return prepare;
  else if (prepare.endsWith('.')) return `${prepare}png`;
  return `${prepare}.png`;
}
